import Component from '../Component';
import $ from '../../vendor/CustomJquery';
import Routes from '../../routes';

export default class AutoTranslate extends Component {

  configure() {
    return super.configure();
  }

  initialize() {

    this.form = $('.is-city-form');
    this.name = this.form.find('input[name="name"]');
    this.control = this.name.closest('.control');
    this.names = this.form.find('input[name$="[name]"]');
    this.autoTranslateCheckbox = this.form.find('input[name="auto_translate"]');

    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {
    // Fill Russian value by default
    this.name.keyup((event) => {
      this.form.find('input[name="values[ru][name]"]').val(
        $(event.currentTarget).val()
      );
    });

    // Translate value to other languages
    this.name.blur(() => {

      if (this.name.val().length === 0)
        return false;

      this.control.addClass('is-loading');

      if (this.autoTranslateCheckbox.is(':checked')) {

        this.names.each((index, element) => {
          element = $(element);
          let language = element.data('language');
          if (language !== 'ru') {
            this.translate(
              this.name.val(),
              'ru',
              language,
              element
            );
          }
        });

        setTimeout(() => {
          this.control.removeClass('is-loading');
        }, 1000);

      }
    });

  }

  translate(phrase, from, to, target) {

    this.search(phrase, from, to, (result) => {
      this.logger(`Phrase "${phrase}" was translated to`, result);
      target.val(result);
    });

  }

  search(query, from, to, callback) {

    return this.App.API.get(Routes.API.CONTENT.TRANSLATE, {
      query: query,
      from:  from,
      to:    to
    }).then((response) => {

      if (response.data) {

        if (typeof response.data.data != 'undefined' && response.data.data.length > 0) {
          return callback(response.data.data);
        }

        return callback('');

      }

      callback('');

      return this.App.UI.Dialog.alert(
        this.App.Language.get('errors.internal_error')
      );

    }).catch((error) => {

      callback('');

      return this.App.UI.Dialog.alert(
        this.App.Language.get('errors.internal_error')
      );

    });

  }

}